/**
 * CENTRALIZED EVENT HANDLING FOR DOCUMENT-WIDE EVENTS
 * e.g., resize, scroll, or custom events
 */

/**
 * BREAKPOINT HANDLER
 */

PJS = window.PJS || {};

(function( $ ) {
  var initialized = false;

  var RESIZE_LISTENERS = [],
    SCROLL_LISTENERS = [],
    DELAYEDINIT_LISTENERS = [],

    listenedToScroll = false,
    listenedToResize = false,
    listenedToDelay = false,
    pageinteraction = false,

    $window = $(window),
    $document = $(document),

    // Helpers
    debounce,
    checkIf
    ;

  function listenToResize () {
    listenedToResize = true;
    $window.on('resize', function () {
      var dimensions = { width: window.innerWidth, height: window.innerHeight };
      RESIZE_LISTENERS.forEach(function ( _handlerFunction ) {
        _handlerFunction(dimensions);
      });
    });
  }

  function listenToScroll () {
    listenedToScroll = true;
    $window.on('scroll', function () {
      var currentScroll = window.pageYOffset;
      checkfordelay();
      SCROLL_LISTENERS.forEach(function ( _handlerFunction ) {
        _handlerFunction(currentScroll);
      });
    });
  }

  function listenToDelay () {
    listenedToDelay = true;
  }

  function checkfordelay() {
    if (window.pageYOffset > 0 || window.location.hash != "") {  // execute when page is moved, or if loading hash
      pageinteraction = true;
    }
    if (DELAYEDINIT_LISTENERS.length == 0) return;
    if (pageinteraction) {
      var alength = DELAYEDINIT_LISTENERS.length;
      for(j = 0; j < alength; j++) {
        console.log("execute delay: "+ DELAYEDINIT_LISTENERS[0].name);
        DELAYEDINIT_LISTENERS[0]();
        DELAYEDINIT_LISTENERS.splice(0,1);
      };
    }
  }


  /**
   * Breakpoint handler attached to App
   */
  PJS.documentEvents = {

    // Register methods
    init: function () {

      if ( initialized ) { return; }
      initialized = true;

      debounce = PJS.helpers.debounce;
      checkIf = PJS.helpers.checkIf;

      /**
       * Registers a resize listener
       * A registered listener is debounced by default, for optimal performance
       *
       * @param {Function} handler - The callback function to call. Required.
       * @param {Boolean} debounce - Whether to debounce the callback. Defaults to true
       */
      this.onResize = function ( handler, willDebounce ) {

        if ( checkIf(handler).isNot(Function) ) { return; }

        willDebounce = false === debounce ? false : true;
        handler = willDebounce ? debounce(handler, 100) : handler;

        RESIZE_LISTENERS.push(handler);

        if ( !listenedToResize ) { listenToResize(); }

      };

      /**
       * Registers a scroll listener
       * @param  {Function} handler
       */
      this.onScroll = function ( handler ) {
        if ( checkIf(handler).isNot(Function) ) { return; }
        SCROLL_LISTENERS.push(handler);

        if ( !listenedToScroll ) { listenToScroll(); }
      };



      /**
       * Registers delayed init function to minimize upfront js
       * @param  {Function} handler
       */
      this.onDelayInit = function ( handler ) {
        if ( checkIf(handler).isNot(Function) ) { return; }
        DELAYEDINIT_LISTENERS.push(handler);

        checkfordelay();
      };

    },

  };
})(jQuery);
